import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface PropsType {
    className?: string;
    onClick?: () => void;
}

export const CMSIcon = observer(
    'CMSIcon',
    ({ className, onClick }: PropsType): JSX.Element => (
        <SvgElement
            className={className}
            onClick={onClick}
            fill='none'
            width='28'
            height='28'
            viewBox='0 0 28 28'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                stroke='#E4E4E7'
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M12.25 23.333H4.667A2.333 2.333 0 0 1 2.333 21V5.833A2.34 2.34 0 0 1 4.667 3.5h4.585a2.334 2.334 0 0 1 1.936 1.05l.957 1.4A2.333 2.333 0 0 0 14.082 7h9.251a2.333 2.333 0 0 1 2.334 2.333v3.5M24.5 21a3.5 3.5 0 0 1-3.5 3.5m3.5-3.5a3.5 3.5 0 0 0-3.5-3.5m3.5 3.5h1.167M21 24.5a3.5 3.5 0 0 1-3.5-3.5m3.5 3.5v1.167M17.5 21a3.5 3.5 0 0 1 3.5-3.5M17.5 21h-1.167M21 17.5v-1.167m3.5 1.167-1.027 1.027m-4.946 4.946L17.5 24.5m7 0-1.027-1.027m-4.946-4.946L17.5 17.5'
            />
        </SvgElement>
    )
);
